import getCategoryId from "./getCategoryId";

export default state => state.category.faqs?.[getCategoryId(state)];
